// AdminEmployees.jsx
import React, { useState } from 'react';
import { Users, UserPlus } from 'lucide-react';
import TabPageLayout from 'modules/swiftboard/components/TabPageLayout'; 
import UserRole from './user-role/UserRole';
import ModuleMaster from './module-master/ModuleMaster';
import useUrlTab from "modules/swiftboard/components/useUrlTab";
 
const Roles = () => {
 
  const [activeTab, setActiveTab] = useUrlTab(["user-roles", "module-master"]);
  const [tabCounts, setTabCounts] = useState({});

  const setTabCount = (tabId) => (count) =>
    setTabCounts((prev) => (prev[tabId] === count ? prev : { ...prev, [tabId]: count }));
 
  const centralDirectoryTabs = [
    {
      id: 1,
      label: 'User Roles',
      icon: <Users size={18} />,
    },
    {
      id: 2,
      label: 'Module Master',
      icon: <UserPlus size={18} />,
    }
  ].map((tab, index) => ({
    ...tab,
    badge:
      index === activeTab && tabCounts[tab.id] !== undefined
        ? { count: tabCounts[tab.id], compact: true }
        : undefined,
  }));

  const handleTabChange = (index, tab) => {
    setActiveTab(index);
  };




  return (
    <TabPageLayout
      tabs={centralDirectoryTabs}
      activeTab={activeTab}
      onTabChange={handleTabChange}
    >
      {activeTab === 0 && <UserRole onTotalCountChange={setTabCount(1)} />}
      {activeTab === 1 && <ModuleMaster onTotalCountChange={setTabCount(2)} />}
    </TabPageLayout>
  );
};

export default Roles;